import { render, staticRenderFns } from "./ServeSale202301Step1.vue?vue&type=template&id=b272bfe0&scoped=true"
import script from "./ServeSale202301Step1.vue?vue&type=script&lang=js"
export * from "./ServeSale202301Step1.vue?vue&type=script&lang=js"
import style0 from "./ServeSale202301Step1.vue?vue&type=style&index=0&id=b272bfe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b272bfe0",
  null
  
)

export default component.exports